export default "__VITE_ASSET__CsykSgh4__"